import { render, staticRenderFns } from "./publishTikTok.vue?vue&type=template&id=556ce8ad&scoped=true&"
import script from "./publishTikTok.vue?vue&type=script&lang=js&"
export * from "./publishTikTok.vue?vue&type=script&lang=js&"
import style0 from "./publishTikTok.vue?vue&type=style&index=0&id=556ce8ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556ce8ad",
  null
  
)

export default component.exports